/**
 * Truncates text to a specified word limit and adds ellipsis
 * @param text - The text to truncate
 * @param wordLimit - Maximum number of words to display
 * @returns Truncated text with ellipsis if needed
 */
export const truncateText = (text: string, wordLimit: number): string => {
  if (!text) return '';
  
  const words = text.split(' ');
  if (words.length <= wordLimit) {
    return text;
  }
  
  return words.slice(0, wordLimit).join(' ') + '...';
};

/**
 * Truncates text to a specified character limit and adds ellipsis
 * @param text - The text to truncate
 * @param charLimit - Maximum number of characters to display
 * @returns Truncated text with ellipsis if needed
 */
export const truncateTextByChars = (text: string, charLimit: number): string => {
  if (!text) return '';
  
  if (text.length <= charLimit) {
    return text;
  }
  
  return text.slice(0, charLimit).trim() + '...';
};